import React, { FunctionComponent, useCallback } from 'react';
import { DragDropContext, DropResult } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';
import { reorderUserWidgets } from '../../../../../app/page/page-storage/user-settings/user-settings.actions';

export const WidgetsDragDropContext: FunctionComponent = ({ children }) => {
  const dispatch = useDispatch();
  const handleDrop = useCallback(
    (result: DropResult) => {
      dispatch(reorderUserWidgets(result));
    },
    [dispatch],
  );

  return <DragDropContext onDragEnd={handleDrop}>{children}</DragDropContext>;
};
